module.exports = __webpack_public_path__ + "img/index-new-01.3c096d5f.svg";